export default class Plugin {
    constructor (dto) {
        this.id = 0
        this.name = ''
        this.contentTypeIDs = []
        this.icon = 'mdi-power-plug'
        this.location = ''
        this.automaticAuthorization = false
        this.pluginConfig = {},
        this.pluginContentFileName = ''
        this.pluginContentBase64 = ''

        if (dto) {
            this.id = dto.Id
            this.name = dto.Name
            this.contentTypeIDs = dto.ContentTypeIDs.map(x => x + '')
            this.icon = dto.Icon
            this.location = dto.Location
            this.pluginContentFileName = dto.PluginContentPath
            if(dto.PluginConfig){
                this.pluginConfig = JSON.parse(dto.PluginConfig)
            }
        }
    }

    toDto () {
        return {
            Id: this.id,
            Name: this.name,
            ContentTypeIDs: this.contentTypeIDs.map(x => parseInt(x)),
            Icon: this.icon,
            Location: this.location,
            AutomaticAuthorization: this.automaticAuthorization,
            PluginConfig: JSON.stringify(this.pluginConfig),
            PluginContent: {
                FileName: this.pluginContentFileName,
                Base64File: this.pluginContentBase64,
            },
        }
    }
}
